import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Switch,
  Text,
  Spinner,
  FormHelperText,
  Heading,
  Divider,
  Grid,
  GridItem,
  Alert,
  AlertIcon,
  FormErrorMessage,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { componentState } from "../../../atoms/componentState";
import TitleFlex from "./components/titleFlex";
import { NumericFormat, PatternFormat } from "react-number-format";
import { stateOptions } from "../../../constants/stateOptions";
import moment from "moment";
import { dateForAPI, dateForValueInput } from "../../../constants/dataFormat";
import { cnpj as cnpjValidator, cpf as cpfValidator } from "cpf-cnpj-validator";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import VendasBoletoIndividualApi from "../../../services/VendasBoletoIndividuaApi";
import ModalRevisãoVendaBoleto from "./components/ModalRevisãoVendaBoleto";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { goToVendaBolePixListagem } from "../../../routes/coordinator";
import { customColors } from "../../../atoms/customColors";
import { useSetRecoilState, useRecoilState } from "recoil";

export interface VendaBoleto {
  idCliente: number;
  valor: number;
  vencimento: string;
  descricao: string;
  cpfPagador: string;
  nomePagador: string;
  emailPagador: string;
  enderRua: string;
  enderBairro: string;
  enderCEP: string;
  enderCidade: string;
  enderComplemento: string;
  enderEstado: string;
  enderNumero: string;
  enderReferencia: string;
  permitirRegras: boolean;
  RegrasJuros: {
    mode: string;
    frequency: string | null;
    value: number;
    start_at: string;
  };
  RegrasMulta: {
    mode: string;
    value: number;
    start_at: string;
  };
  RegrasDesconto: {
    mode: string;
    value: number;
    limit_at: string;
  };
}

interface BoletoModal {
  idLogin: number;
  idCliente: number;
  dataVencimento: string;
  dataEmissao: string;
  isAvulso: boolean;
  valor: number;
  mensagem: string;
  cpfPagador: string;
  nomePagador: string;
  emailPagador: string;
  enderRua: string;
  enderBairro: string;
  enderCEP: string;
  enderCidade: string;
  enderComplemento: string;
  enderEstado: string;
  enderNumero: string;
  enderReferencia: string;
  permitirRegras: boolean;
  RegrasJuros: {
    mode: string | null;
    frequency: string | null;
    value: string;
    start_at: string;
  } | null;
  RegrasMulta: {
    mode: string | null;
    value: string;
    start_at: string;
  };
  RegrasDesconto: {
    mode: string | null;
    value: string;
    limit_at: string;
  } | null;
}

function toCentsExact(value: any) {
  if (value == null) throw new Error("Input value cannot be null or undefined");
  let valueStr = value.toString().replace(",", ".");
  const num = parseFloat(valueStr);
  if (isNaN(num)) throw new Error("Invalid number format");
  return Math.round(num * 100);
}

export default function VendasBolePix() {
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Venda no Boleto");
  }, []);

  const navigate = useNavigate();
  const colors = useRecoilState(customColors)[0];

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const cliente = Number(jwtToken.idCliente);
  const login = Number(jwtToken.primarysid);
  const unMask = (value: any) => value.replace(/[^0-9]/g, "");

  const initialValues: VendaBoleto = {
    idCliente: 0,
    valor: 0,
    vencimento: "",
    descricao: "",
    cpfPagador: "",
    nomePagador: "",
    emailPagador: "",
    enderRua: "",
    enderBairro: "",
    enderCEP: "",
    enderCidade: "",
    enderComplemento: "",
    enderEstado: "AC",
    enderNumero: "",
    enderReferencia: "",
    permitirRegras: false,
    RegrasJuros: {
      mode: "SEM_JUROS",
      frequency: null,
      value: 0,
      start_at: "",
    },
    RegrasMulta: {
      mode: "SEM_MULTA",
      value: 0,
      start_at: "",
    },
    RegrasDesconto: {
      mode: "SEM_DESCONTO",
      value: 0,
      limit_at: "",
    },
  };

  const [boleto, setBoleto] = useState<VendaBoleto>(initialValues);
  const [objetoModal, setObjetoModal] = useState<BoletoModal | null>(null);
  const [responseToModal, setResponseToModal] = useState<any>();
  const [isOpen, setIsOpen] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const [validation, setValidation] = useState(false);

  const getInterestConfig = (currentMode: string) => {
    switch (currentMode) {
      case "VALOR_DIARIO":
        return { mode: "FIXED", frequency: "DAILY", isPercentage: false };
      case "PERCENTUAL_DIARIO":
        return { mode: "PERCENTAGE", frequency: "DAILY", isPercentage: true };
      case "PERCENTUAL_MENSAL":
        return { mode: "PERCENTAGE", frequency: "MONTHLY", isPercentage: true };
      case "SEM_JUROS":
      default:
        return { mode: "SEM_JUROS", frequency: null, isPercentage: false }; // Não retorne null aqui
    }
  };

  const getMultaConfig = (currentMode: string) => {
    switch (currentMode) {
      case "FIXED":
        return { mode: "FIXED", isPercentage: false };
      case "PERCENTAGE":
        return { mode: "PERCENTAGE", isPercentage: true };
      case "SEM_MULTA":
      default:
        return { mode: "SEM_MULTA", isPercentage: false }; // Não retorne null aqui
    }
  };
  const convertValueToCentsString = (
    value: number,
    isPercentage: boolean
  ): string => {
    if (isPercentage) {
      return Math.round(value * 100).toString();
    } else {
      return toCentsExact(value).toString();
    }
  };

  function validarSeFinalDeSemana(e: any) {
    const data = new Date(e.target.value);
    const ehFinalDeSemana = data.getDay() === 5 || data.getDay() === 6;
    if (ehFinalDeSemana) {
      toast.error("A data não pode ser um final de semana!");
      return;
    }
    setBoleto({
      ...boleto,
      vencimento: moment(e.target.value).format(dateForAPI),
      RegrasJuros: boleto.RegrasJuros
        ? {
          ...boleto.RegrasJuros,
          start_at: moment(e.target.value).format(dateForAPI),
        }
        : boleto.RegrasJuros,
      RegrasMulta: {
        ...boleto.RegrasMulta,
        start_at: moment(e.target.value).format(dateForAPI),
      },
    });
  }

  function validaData(item: any) {
    if (moment(item).isBefore(moment().startOf("day"))) {
      toast.error("A data não pode ser anterior ao dia de hoje!");
    }
  }

  const podeAplicarRegras = boleto.valor >= 10;

  // Limites legais (BACEN) — valores em % real (o ×100 só ocorre no build do objeto)
  const LIMITE_MULTA_PCT = 2; // CDC Art. 52 §1
  const LIMITE_JUROS_MENSAL_PCT = 1; // Art. 406 CC / Art. 161 CTN
  const LIMITE_JUROS_DIARIO_PCT = 1 / 30; // 0,0333% ao dia (1% ao mês)

  const getRegraJurosErro = (): string | null => {
    const rj = boleto.RegrasJuros;
    if (!boleto.permitirRegras || !rj || rj.mode === "SEM_JUROS") return null;
    const v = Number(rj.value) || 0;
    if (v <= 0) return "Informe o valor do juros.";
    if (rj.mode === "PERCENTUAL_MENSAL" && v > LIMITE_JUROS_MENSAL_PCT)
      return "Juros mensal não pode exceder 1% (limite legal).";
    if (rj.mode === "PERCENTUAL_DIARIO" && v > LIMITE_JUROS_DIARIO_PCT)
      return "Juros diário não pode exceder 0,033% (equivale a 1% ao mês).";
    if (rj.mode === "VALOR_DIARIO") {
      // R$/dia ≤ 0,033% do valor por dia (piso de R$ 0,01/dia — regra BACEN)
      const tetoJurosDia = Math.max(
        boleto.valor * (LIMITE_JUROS_DIARIO_PCT / 100),
        0.01
      );
      if (v > tetoJurosDia)
        return `Juros diário fixo não pode exceder 0,033%/dia do valor do boleto (máx. R$ ${tetoJurosDia
          .toFixed(2)
          .replace(".", ",")}/dia).`;
    }
    return null;
  };

  const getRegraMultaErro = (): string | null => {
    const rm = boleto.RegrasMulta;
    if (!boleto.permitirRegras || !rm || rm.mode === "SEM_MULTA") return null;
    const v = Number(rm.value) || 0;
    if (v <= 0) return "Informe o valor da multa.";
    if (rm.mode === "PERCENTAGE" && v > LIMITE_MULTA_PCT)
      return "Multa não pode exceder 2% (limite legal).";
    if (rm.mode === "FIXED") {
      const tetoMulta = boleto.valor * (LIMITE_MULTA_PCT / 100);
      if (v > tetoMulta)
        return `Multa fixa não pode exceder 2% do valor do boleto (máx. R$ ${tetoMulta
          .toFixed(2)
          .replace(".", ",")}).`;
    }
    return null;
  };

  const getRegraDescontoErro = (): string | null => {
    const rd = boleto.RegrasDesconto;
    if (!boleto.permitirRegras || !rd || rd.mode === "SEM_DESCONTO") return null;
    const v = Number(rd.value) || 0;
    if (v <= 0) return "Informe o valor do desconto.";
    if (rd.mode === "PERCENTAGE" && v >= 100)
      return "Desconto percentual não pode ser igual ou maior que 100%.";
    if (rd.mode === "FIXED" && v >= boleto.valor)
      return "Desconto não pode ser igual ou maior que o valor do boleto.";
    if (!rd.limit_at) return "Informe a data-limite do desconto.";
    if (moment(rd.limit_at).isBefore(moment(), "day"))
      return "A data-limite do desconto não pode ser anterior a hoje.";
    if (
      boleto.vencimento &&
      moment(rd.limit_at).isAfter(moment(boleto.vencimento), "day")
    )
      return "A data-limite do desconto deve ser até o vencimento.";
    return null;
  };

  const fmtBRL = (n: number) =>
    n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  const tetoMultaFixa = boleto.valor * (LIMITE_MULTA_PCT / 100);
  const tetoJurosDiaFixo = Math.max(
    boleto.valor * (LIMITE_JUROS_DIARIO_PCT / 100),
    0.01
  );

  const onChangeValorFixo = (e: any) => {
    const raw = e.target.value.slice(3).replace(",", ".");
    const valor = parseFloat(raw) || 0;
    setBoleto({
      ...boleto,
      valor,
      permitirRegras: valor >= 10 ? boleto.permitirRegras : false,
    });
  };

  async function onSubmit() {
    if (boleto.valor < 5) {
      toast.error("O boleto deve ter valor mínimo de R$ 5,00.");
      setLoadingState(false);
      return;
    }

    const erroRegra =
      getRegraJurosErro() || getRegraMultaErro() || getRegraDescontoErro();
    if (erroRegra) {
      toast.error(erroRegra);
      setLoadingState(false);
      return;
    }

    const interestConfig = getInterestConfig(
      boleto.RegrasJuros?.mode || "SEM_JUROS"
    );
    const multaConfig = getMultaConfig(boleto.RegrasMulta.mode);

    const objeto: BoletoModal = {
      idCliente: cliente,
      idLogin: login,
      dataVencimento: boleto.vencimento,
      dataEmissao: moment().format(dateForAPI),
      isAvulso: true,
      valor: boleto.valor,
      mensagem: boleto.descricao,
      cpfPagador: unMask(boleto.cpfPagador),
      nomePagador: boleto.nomePagador,
      emailPagador: boleto.emailPagador,
      enderRua: boleto.enderRua,
      enderBairro: boleto.enderBairro,
      enderCEP: unMask(boleto.enderCEP),
      enderCidade: boleto.enderCidade,
      enderComplemento: boleto.enderComplemento,
      enderEstado: boleto.enderEstado,
      enderNumero: boleto.enderNumero,
      enderReferencia: boleto.enderReferencia,
      permitirRegras: boleto.permitirRegras,
      RegrasJuros: {
        mode:
          boleto.permitirRegras && interestConfig.mode !== "SEM_JUROS"
            ? interestConfig.mode
            : "SEM_JUROS",
        frequency:
          boleto.permitirRegras && interestConfig.mode !== "SEM_JUROS"
            ? interestConfig.frequency
            : null,
        value:
          boleto.permitirRegras && interestConfig.mode !== "SEM_JUROS"
            ? convertValueToCentsString(
              boleto.RegrasJuros?.value || 0,
              interestConfig.isPercentage
            )
            : "0",
        start_at: boleto.vencimento,
      },
      RegrasMulta: {
        mode:
          boleto.permitirRegras && multaConfig.mode !== "SEM_MULTA"
            ? multaConfig.mode
            : "SEM_MULTA",
        value:
          boleto.permitirRegras && multaConfig.mode !== "SEM_MULTA"
            ? convertValueToCentsString(
              boleto.RegrasMulta.value,
              multaConfig.isPercentage
            )
            : "0",
        start_at: boleto.vencimento,
      },
      RegrasDesconto: {
        mode:
          boleto.permitirRegras &&
            boleto.RegrasDesconto.mode !== "SEM_DESCONTO"
            ? boleto.RegrasDesconto.mode
            : "SEM_DESCONTO",
        value:
          boleto.permitirRegras &&
            boleto.RegrasDesconto.mode !== "SEM_DESCONTO"
            ? convertValueToCentsString(
              boleto.RegrasDesconto.value,
              boleto.RegrasDesconto.mode === "PERCENTAGE"
            )
            : "0",
        limit_at: boleto.RegrasDesconto.limit_at,
      },
    };

    console.log("Objeto enviado:", objeto); // Adicione este console.log para debug
    setObjetoModal(objeto);
    setIsOpen(true);
    // Modal aberta assume o controle; libera o botão da página.
    setLoadingState(false);
  }

  async function postPayment(obj: any) {
    setLoadingState(true);
    try {
      setObjetoModal(obj);
      const response = await VendasBoletoIndividualApi.postVendaBolePix(obj);
      setResponseToModal(response);
      setBoleto(initialValues);
      setIsOpen(true);
      toast.success("Boleto criado com sucesso!");
    } catch (error: any) {
      setIsOpen(false);
      if (error.response?.data?._error?.error) {
        const { message, reasons } = error.response.data._error.error;
        const errorTranslations: { [key: string]: string } = {
          "Late fee mode is not valid": "O modo de multa está inválido",
          "Late fee start date must be greater than the expiration date":
            "A data de início da multa deve ser maior que a data de vencimento",
          "Interest mode is not valid": "O modo de juros está inválido",
          "Invalid value fields": "Campos de valor inválidos",
          "Amount is more than limit": "O valor excede o limite permitido",
        };
        const translated = reasons.map(
          (r: string) => errorTranslations[r] || r
        );
        toast.error(`Erro: ${message}. Motivos: ${translated.join("; ")}`);
      } else {
        toast.error(error.response?.data?.message || JSON.stringify(error));
      }
    } finally {
      setLoadingState(false);
    }
  }

  function validateCPForCNPJ(item: any) {
    const temp = unMask(item);
    const isCpf = temp.length === 11;
    const valid = isCpf
      ? cpfValidator.isValid(temp)
      : cnpjValidator.isValid(temp);
    setValidation(!valid);
  }

  async function addressCep(cep: any) {
    try {
      if (unMask(cep).length >= 8) {
        const { data } = await axios.get(
          `https://viacep.com.br/ws/${cep}/json/`
        );
        setBoleto((prev) => ({
          ...prev,
          enderRua: data.logradouro,
          enderBairro: data.bairro,
          enderCEP: data.cep,
          enderCidade: data.localidade,
          enderComplemento: data.complemento,
          enderEstado: data.uf,
        }));
      }
    } catch (err) {
      console.error(err);
    }
  }

  const OPTIONS_INTEREST = [
    { key: 1, value: "SEM_JUROS", text: "Sem juros" },
    { key: 2, value: "VALOR_DIARIO", text: "Valor fixo diário" },
    { key: 3, value: "PERCENTUAL_DIARIO", text: "Percentual diário" },
    { key: 4, value: "PERCENTUAL_MENSAL", text: "Percentual mensal" },
  ];

  const OPTIONS_MULTA = [
    { key: 1, value: "SEM_MULTA", text: "Sem Multa" },
    { key: 2, value: "FIXED", text: "Valor Fixo" },
    { key: 3, value: "PERCENTAGE", text: "Percentual" },
  ];

  const OPTIONS_DESCONTO = [
    { key: 1, value: "SEM_DESCONTO", text: "Sem Desconto" },
    { key: 2, value: "FIXED", text: "Valor Fixo" },
    // Percentual preparado no back/validação, mas oculto no front por ora:
    // { key: 3, value: "PERCENTAGE", text: "Percentual" },
  ];

  const isFormValid = () => {
    return (
      cliente > 0 &&
      boleto.valor >= 5 &&
      boleto.cpfPagador !== "" &&
      boleto.emailPagador !== "" &&
      boleto.nomePagador !== "" &&
      boleto.enderCEP !== "" &&
      boleto.enderRua !== "" &&
      boleto.enderNumero !== "" &&
      boleto.enderBairro !== "" &&
      boleto.enderCidade !== "" &&
      boleto.enderEstado !== "" &&
      !getRegraJurosErro() &&
      !getRegraMultaErro() &&
      !getRegraDescontoErro()
    );
  };

  return (
    <Flex
      w={"100%"}
      h={"90vh"}
      bgColor={colors.WHITE}
      p={{ base: 4, md: 8 }}
      shadow="lg"
      overflowY="auto"
      flexDir="column"
      maxW="1400px"
      mx="auto"
    >
      <Box mb={6}>
        <Flex alignItems="center" mb={4}>
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="28px" />
          <Heading as="h1" size="lg" ml={3} color={colors.BLUEMONEDDBUTTONS}>
            Criar BOLEPIX Individual
          </Heading>
        </Flex>
        <Divider borderColor="gray.200" />
      </Box>

      <Box mb={8}>
        <TitleFlex item="Informações de Pagamento" />
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
          gap={4}
          my={4}
        >
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Valor (mínimo R$ 5,00)</FormLabel>
              <NumericFormat
                decimalScale={2}
                prefix="R$ "
                value={boleto.valor}
                decimalSeparator=","
                customInput={Input}
                placeholder="R$ 0,00"
                onChange={onChangeValorFixo}
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Data de Vencimento</FormLabel>
              <Input
                type="date"
                value={moment(boleto.vencimento).format(dateForValueInput)}
                min={moment().startOf("day").format(dateForValueInput)}
                onChange={validarSeFinalDeSemana}
                onBlur={(e) => validaData(e.target.value)}
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl>
              <FormLabel>Descrição</FormLabel>
              <Input
                placeholder="Opcional"
                value={boleto.descricao}
                onChange={(e) =>
                  setBoleto({ ...boleto, descricao: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Box>

      <Box mb={8}>
        <Flex alignItems="center" mb={4}>
          <Switch
            size="md"
            mr={3}
            isChecked={boleto.permitirRegras}
            isDisabled={!podeAplicarRegras}
            onChange={() => {
              if (podeAplicarRegras) {
                setBoleto({
                  ...boleto,
                  permitirRegras: !boleto.permitirRegras,
                  RegrasJuros: {
                    mode: "SEM_JUROS",
                    frequency: null,
                    value: 0,
                    start_at: boleto.vencimento,
                  },
                  RegrasMulta: {
                    mode: "SEM_MULTA",
                    value: 0,
                    start_at: boleto.vencimento,
                  },
                  RegrasDesconto: {
                    mode: "SEM_DESCONTO",
                    value: 0,
                    limit_at: "",
                  },
                });
              }
            }}
          />
          <Text fontWeight="medium">
            Aplicar Regras de Juros e Multa{" "}
            {boleto.valor < 10 && "(mínimo R$ 10,00)"}
          </Text>
        </Flex>

        {boleto.permitirRegras && (
          <>
            <TitleFlex item="Regras do Boleto" />

            {/* Bloco 1 — Juros e Multa */}
            <Box
              borderWidth="1px"
              borderColor="gray.200"
              borderRadius="md"
              p={4}
              mb={4}
            >
              <Text fontWeight="bold" fontSize="md" mb={2}>
                Juros e Multa
              </Text>
              <Alert
                status="info"
                variant="left-accent"
                borderRadius="md"
                mb={4}
                alignItems="flex-start"
              >
                <AlertIcon />
                <Box fontSize="sm">
                  <Text>
                    <b>Multa</b> — única, aplicada após o vencimento: valor fixo
                    em R$ ou percentual (<b>máx. 2%</b>).
                  </Text>
                  <Text>
                    <b>Juros</b> — por dia de atraso: valor fixo diário em R$, ou
                    percentual <b>diário (máx. 0,033%)</b> ou{" "}
                    <b>mensal (máx. 1%)</b>.
                  </Text>
                  <Text color="gray.600">
                    Para boletos abaixo de R$ 100,00, o juros mínimo é 1 centavo
                    por dia.
                  </Text>
                </Box>
              </Alert>
              <Grid
                templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
                gap={4}
              >
              <GridItem>
                <FormControl>
                  <FormLabel>Regras de Juros</FormLabel>
                  <Select
                    value={boleto.RegrasJuros?.mode || "SEM_JUROS"}
                    onChange={(e) => {
                      const config = getInterestConfig(e.target.value);
                      setBoleto({
                        ...boleto,
                        RegrasJuros: {
                          mode: e.target.value,
                          frequency: config.frequency,
                          value: 0,
                          start_at: boleto.vencimento,
                        },
                      });
                    }}
                  >
                    {OPTIONS_INTEREST.map((item) => (
                      <option key={item.key} value={item.value}>
                        {item.text}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {boleto.RegrasJuros?.mode === "PERCENTUAL_DIARIO" && (
                  <FormControl mt={4} isInvalid={!!getRegraJurosErro()}>
                    <FormLabel>Percentual Diário (%)</FormLabel>
                    <NumericFormat
                      decimalSeparator=","
                      decimalScale={3}
                      customInput={Input}
                      value={boleto.RegrasJuros.value}
                      placeholder="0,000"
                      onValueChange={({ value }) => {
                        const num = parseFloat(value.replace(",", ".")) || 0;
                        setBoleto({
                          ...boleto,
                          RegrasJuros: { ...boleto.RegrasJuros!, value: num },
                        });
                      }}
                    />
                    <FormErrorMessage>{getRegraJurosErro()}</FormErrorMessage>
                    <FormHelperText>Máx. 0,033% ao dia.</FormHelperText>
                  </FormControl>
                )}

                {boleto.RegrasJuros?.mode === "PERCENTUAL_MENSAL" && (
                  <FormControl mt={4} isInvalid={!!getRegraJurosErro()}>
                    <FormLabel>Percentual Mensal (%)</FormLabel>
                    <NumericFormat
                      decimalSeparator=","
                      decimalScale={2}
                      customInput={Input}
                      value={boleto.RegrasJuros.value}
                      placeholder="0,00"
                      onValueChange={({ value }) => {
                        const num = parseFloat(value.replace(",", ".")) || 0;
                        setBoleto({
                          ...boleto,
                          RegrasJuros: { ...boleto.RegrasJuros!, value: num },
                        });
                      }}
                    />
                    <FormErrorMessage>{getRegraJurosErro()}</FormErrorMessage>
                    <FormHelperText>Máx. 1% ao mês.</FormHelperText>
                  </FormControl>
                )}

                {boleto.RegrasJuros?.mode === "VALOR_DIARIO" && (
                  <FormControl mt={4} isInvalid={!!getRegraJurosErro()}>
                    <FormLabel>Valor Diário (R$)</FormLabel>
                    <NumericFormat
                      decimalSeparator=","
                      decimalScale={2}
                      customInput={Input}
                      value={boleto.RegrasJuros.value}
                      placeholder="0,00"
                      onValueChange={({ value }) => {
                        const num = parseFloat(value.replace(",", ".")) || 0;
                        setBoleto({
                          ...boleto,
                          RegrasJuros: { ...boleto.RegrasJuros!, value: num },
                        });
                      }}
                    />
                    <FormErrorMessage>{getRegraJurosErro()}</FormErrorMessage>
                    <FormHelperText>
                      Valor máximo: {fmtBRL(tetoJurosDiaFixo)}/dia (0,033%/dia).
                    </FormHelperText>
                  </FormControl>
                )}
              </GridItem>

              <GridItem>
                <FormControl>
                  <FormLabel>Regra de Multa</FormLabel>
                  <Select
                    value={boleto.RegrasMulta.mode}
                    onChange={(e) =>
                      setBoleto({
                        ...boleto,
                        RegrasMulta: {
                          ...boleto.RegrasMulta,
                          mode: e.target.value,
                          value: 0,
                          start_at: boleto.vencimento,
                        },
                      })
                    }
                  >
                    {OPTIONS_MULTA.map((item) => (
                      <option key={item.key} value={item.value}>
                        {item.text}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {boleto.RegrasMulta.mode === "FIXED" && (
                  <FormControl mt={4} isInvalid={!!getRegraMultaErro()}>
                    <FormLabel>Valor Fixo (R$)</FormLabel>
                    <NumericFormat
                      decimalSeparator=","
                      decimalScale={2}
                      customInput={Input}
                      value={boleto.RegrasMulta.value}
                      placeholder="0,00"
                      onValueChange={({ value }) => {
                        const num = parseFloat(value.replace(",", ".")) || 0;
                        setBoleto({
                          ...boleto,
                          RegrasMulta: { ...boleto.RegrasMulta, value: num },
                        });
                      }}
                    />
                    <FormErrorMessage>{getRegraMultaErro()}</FormErrorMessage>
                    <FormHelperText>
                      Valor máximo: {fmtBRL(tetoMultaFixa)} (2% do boleto).
                    </FormHelperText>
                  </FormControl>
                )}

                {boleto.RegrasMulta.mode === "PERCENTAGE" && (
                  <FormControl mt={4} isInvalid={!!getRegraMultaErro()}>
                    <FormLabel>Percentual (%)</FormLabel>
                    <NumericFormat
                      decimalSeparator=","
                      decimalScale={2}
                      customInput={Input}
                      value={boleto.RegrasMulta.value}
                      placeholder="0,00"
                      onValueChange={({ value }) => {
                        const num = parseFloat(value.replace(",", ".")) || 0;
                        setBoleto({
                          ...boleto,
                          RegrasMulta: { ...boleto.RegrasMulta, value: num },
                        });
                      }}
                    />
                    <FormErrorMessage>{getRegraMultaErro()}</FormErrorMessage>
                    <FormHelperText>Máx. 2% do valor do boleto.</FormHelperText>
                  </FormControl>
                )}
                </GridItem>
              </Grid>
            </Box>

            {/* Bloco 2 — Desconto */}
            <Box
              borderWidth="1px"
              borderColor="gray.200"
              borderRadius="md"
              p={4}
              mb={4}
            >
              <Text fontWeight="bold" fontSize="md" mb={2}>
                Desconto por Antecipação
              </Text>
              <Alert
                status="info"
                variant="left-accent"
                borderRadius="md"
                mb={4}
                alignItems="flex-start"
              >
                <AlertIcon />
                <Box fontSize="sm">
                  <Text>
                    Valor em R$ <b>abatido</b> do boleto se pago até a
                    data-limite (entre hoje e o vencimento).
                  </Text>
                </Box>
              </Alert>
              <Grid
                templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
                gap={4}
              >
                <GridItem>
                <FormControl>
                  <FormLabel>Tipo de desconto</FormLabel>
                  <Select
                    value={boleto.RegrasDesconto.mode}
                    onChange={(e) =>
                      setBoleto({
                        ...boleto,
                        RegrasDesconto: {
                          ...boleto.RegrasDesconto,
                          mode: e.target.value,
                          value: 0,
                          limit_at: "",
                        },
                      })
                    }
                  >
                    {OPTIONS_DESCONTO.map((item) => (
                      <option key={item.key} value={item.value}>
                        {item.text}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {boleto.RegrasDesconto.mode !== "SEM_DESCONTO" && (
                  <FormControl mt={4} isInvalid={!!getRegraDescontoErro()}>
                    <FormLabel>
                      {boleto.RegrasDesconto.mode === "PERCENTAGE"
                        ? "Percentual de desconto (%)"
                        : "Valor do desconto (R$)"}
                    </FormLabel>
                    <NumericFormat
                      decimalSeparator=","
                      decimalScale={2}
                      customInput={Input}
                      value={boleto.RegrasDesconto.value}
                      placeholder="0,00"
                      onValueChange={({ value }) => {
                        const num = parseFloat(value.replace(",", ".")) || 0;
                        setBoleto({
                          ...boleto,
                          RegrasDesconto: {
                            ...boleto.RegrasDesconto,
                            value: num,
                          },
                        });
                      }}
                    />
                    <FormErrorMessage>{getRegraDescontoErro()}</FormErrorMessage>
                    <FormHelperText>
                      {boleto.RegrasDesconto.mode === "PERCENTAGE"
                        ? "Percentual abatido do valor do boleto se pago até a data-limite."
                        : "Valor em R$ abatido do total se pago até a data-limite (não pode zerar/superar o boleto)."}
                    </FormHelperText>
                  </FormControl>
                )}
              </GridItem>

              {boleto.RegrasDesconto.mode !== "SEM_DESCONTO" && (
                <GridItem>
                  <FormControl isInvalid={!!getRegraDescontoErro()}>
                    <FormLabel>Válido até (data-limite)</FormLabel>
                    <Input
                      type="date"
                      min={moment().format("YYYY-MM-DD")}
                      max={
                        boleto.vencimento
                          ? moment(boleto.vencimento).format("YYYY-MM-DD")
                          : undefined
                      }
                      value={boleto.RegrasDesconto.limit_at}
                      onChange={(e) =>
                        setBoleto({
                          ...boleto,
                          RegrasDesconto: {
                            ...boleto.RegrasDesconto,
                            limit_at: e.target.value,
                          },
                        })
                      }
                    />
                    <FormHelperText>
                      Entre hoje e o vencimento. O desconto vale se o boleto for
                      pago até esta data.
                    </FormHelperText>
                  </FormControl>
                </GridItem>
              )}
              </Grid>
            </Box>
          </>
        )}
      </Box>

      <Box mb={8}>
        <TitleFlex item="Informações do Pagador" />
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
          gap={4}
          my={4}
        >
          <GridItem>
            <FormControl isRequired isInvalid={validation}>
              <FormLabel>CPF/CNPJ do Pagador</FormLabel>
              <PatternFormat
                customInput={Input}
                format={
                  unMask(boleto.cpfPagador).length > 11
                    ? "##.###.###/####-##"
                    : "###.###.###-###"
                }
                placeholder="Digite o CPF ou CNPJ"
                value={boleto.cpfPagador}
                onChange={(e) =>
                  setBoleto({ ...boleto, cpfPagador: e.target.value })
                }
                onBlur={(e) => validateCPForCNPJ(e.target.value)}
              />
              {validation && (
                <FormHelperText color={colors.REDMONEDD}>
                  Digite um CPF ou CNPJ válido!
                </FormHelperText>
              )}
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Nome do Pagador</FormLabel>
              <Input
                placeholder="Digite o nome"
                value={boleto.nomePagador}
                onChange={(e) =>
                  setBoleto({ ...boleto, nomePagador: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>E-mail</FormLabel>
              <Input
                type="email"
                placeholder="E-mail do Pagador"
                value={boleto.emailPagador}
                onChange={(e) =>
                  setBoleto({ ...boleto, emailPagador: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Box>

      <Box mb={8}>
        <TitleFlex item="Endereço de Cobrança" />
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
          gap={4}
          my={4}
        >
          <GridItem>
            <FormControl isRequired>
              <FormLabel>CEP</FormLabel>
              <PatternFormat
                customInput={Input}
                format="#####-###"
                value={boleto.enderCEP}
                onChange={(e) => {
                  setBoleto({ ...boleto, enderCEP: e.target.value });
                  addressCep(e.target.value);
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Endereço</FormLabel>
              <Input
                value={boleto.enderRua}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderRua: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Número</FormLabel>
              <Input
                value={boleto.enderNumero}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderNumero: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl>
              <FormLabel>Complemento</FormLabel>
              <Input
                value={boleto.enderComplemento}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderComplemento: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl>
              <FormLabel>Referência</FormLabel>
              <Input
                value={boleto.enderReferencia}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderReferencia: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Bairro</FormLabel>
              <Input
                value={boleto.enderBairro}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderBairro: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Cidade</FormLabel>
              <Input
                value={boleto.enderCidade}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderCidade: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Estado</FormLabel>
              <Select
                value={boleto.enderEstado}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderEstado: e.target.value })
                }
              >
                {stateOptions.map((item, index) => (
                  <option value={item.value} key={index}>
                    {item.text}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>
        </Grid>
      </Box>

      <Flex
        justifyContent="space-between"
        w="100%"
        mt={6}
        flexDir={{ base: "column", md: "row" }}
        gap={4}
      >
        <Button
          bgColor={colors.GRAY_DARK}
          color={colors.WHITE}
          w={{ base: "100%", md: "200px" }}
          onClick={() => goToVendaBolePixListagem(navigate)}
        >
          Cancelar
        </Button>
        <Button
          bgColor={colors.BLUEMONEDDBUTTONS}
          color={colors.WHITE}
          isDisabled={!isFormValid() || loadingState}
          w={{ base: "100%", md: "300px" }}
          onClick={async () => {
            setLoadingState(true);
            await onSubmit();
          }}
        >
          {loadingState ? <Spinner size="sm" /> : "Criar Boleto"}
        </Button>
      </Flex>

      <ModalRevisãoVendaBoleto
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        objeto={objetoModal}
        response={responseToModal}
        setResponseToModal={setResponseToModal}
        setBoleto={setBoleto}
        initialValues={initialValues}
        setLoadingState={setLoadingState}
      />
    </Flex>
  );
}
